import { useEffect, useState } from 'react';

import { FEATURE_FLAGS } from '../common/context/FlagsContext';
import { useFeatureFlagsValue } from '../common/context/FlagsValueContext';
import { getFeaturesByClientId } from '../utils/getFeaturesByClientId';

export function useRemove2faSkipForNow() {
  const [remove2faSkipForNow, setRemove2faSkipForNow] = useState(false);
  const flagsContext = useFeatureFlagsValue();

  useEffect(() => {
    const { isRemove2faSkipForNow } = getFeaturesByClientId();
    const enabled =
      flagsContext?.flags?.find(v => v?.flagKey === FEATURE_FLAGS.REMOVE_2FA_SKIP_FOR_NOW?.toString())?.flagValue ??
      false;
    const isFlagEnabled = enabled === true || enabled === 'true';
    setRemove2faSkipForNow(isFlagEnabled && isRemove2faSkipForNow);
  }, [flagsContext]);

  return { remove2faSkipForNow };
}
